<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-12 xl:w-1/2 mx-auto text-center">
            <p></p>
            <img width="400" :src="selectedImage" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">404 - No hay nada por aqu&iacute;!</h1>
            <h6 class="sm:mx-0 mx-4 mb-12 text-2xl">...bueno, bueno s&iacute;...</h6>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-12">"Ok ServiForms, cu&eacute;ntame un chiste" - {{joke}}.</p>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-12">- {{reply}}</p>
            <vs-button size="large" to="/">S&aacute;came de aqu&iacute;!</vs-button>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            joke:'',
            reply:'',
            selectedImage:'404.png',
             imagesList : [
                 '404.png',
                 'memes-spiderman1.webp',
                 'dinosaurio-meme.jpeg'
             ],
            listJokes : [
                {
                    joke:"¿Cuál es la fruta más divertida?",
                    reply:"La naranja ja ja ja ja ja"
                },
                {
                    joke:"¿Qué coche usa Papá Noel?",
                    reply:"Un renol"
                },
                {
                    joke:"¿Qué le dice una iguana a su hermana gemela?",
                    reply:"Somos iguanitas"
                },
                {
                    joke:"¿Quién es el hermano vegetariano de Bruce Lee?",
                    reply:"Broco Lee"
                },
                {
                    joke:"¿Como se llama el hermano enfermo de Hello Kitty?",
                    reply:"Bron Kitty"
                },
                {
                    joke:"¿Cómo pasa Superman entre la gente?",
                    reply:"Consupermiso"
                },
                {
                    joke:"¿Dónde vive Iron Man?",
                    reply:"Iron know"
                },
                {
                    joke:"¿Qué le dijo un perro a otro perro?",
                    reply:"Maiu, era bilingue"
                },
                {
                    joke:"¿Por qué los diabéticos no pueden vengarse?",
                    reply:"Porque la venganza es dulce"
                },
                {
                    joke:"¿Qué es el tiempo si tí?",
                    reply:"empo"
                },
                {
                    joke:"¿Cómo se llama el tío de Thor?",
                    reply:"Hec-Thor"
                },
                {
                    joke:"¿Qué guarda Darth Vader en su nevera?",
                    reply:"Helado oscuro"
                },
                {
                    joke:"Sí los zombies se deshacen con el pasar del tiempo...",
                    reply:"zombiodegradables"
                },
                {
                    joke:"¿En dónde se pegó el tigre tony?",
                    reply:"En zucarita"
                },
                {
                    joke:"¿?",
                    reply:""
                }
            ],
        };
    },
    mounted(){
        let totalImages = this.imagesList.length;
        let pos = Math.floor(Math.random() * totalImages);
        this.selectedImage = require(`@/assets/images/pages/${this.imagesList[pos]}`);

        let totalJokes = this.listJokes.length;
        pos = Math.floor(Math.random() * totalJokes);
        let selected = this.listJokes[pos];
        this.joke= selected.joke;
        this.reply= selected.reply;
    }
};
</script>
